var render = function render(){var _vm=this,_c=_vm._self._c;return _c('g-overlay',{attrs:{"is-relay":_vm.isRelay}})
}
var staticRenderFns = []

export { render, staticRenderFns }